import { type FC } from 'react'
import { FaPallet, FaWeightHanging } from 'react-icons/fa'

import { UnitLabel } from '@/components/elements'
import { CargoWeightFormatter } from '@/features/shared/components'
import { PackageCountFormatter } from '@/features/shipment-order-details/components'
import { mapToShipmentOrdersPackageCategorySummaryData } from '@/features/vehicle-dispatch-boards/models'
import { type ShipmentOrdersListExEntity } from '@/libs/api'

type Props = {
  /** 集計対象（選択された配送依頼） */
  shipmentOrders: ShipmentOrdersListExEntity[]
}

/**
 * 選択された配送依頼の合計（重量・荷姿数）をテーブル上部の選択オーバーレイに表示する。
 * 集計ロジックは配車板の一括配車（DispatchDetailShipmentOrderColumns）と揃える。
 * 重量は kg で合算し選択中拠点の表示形式（単位・小数桁数）で表示、荷姿数は荷姿カテゴリ別に合算する。
 */
export const ShipmentOrdersSelectionSummary: FC<Props> = ({
  shipmentOrders
}) => {
  const totalWeightKg = shipmentOrders.reduce(
    (acc, order) => acc + (order.weight ?? 0),
    0
  )
  const packageCategorySummaries =
    mapToShipmentOrdersPackageCategorySummaryData(shipmentOrders)

  return (
    <div className="flex items-center gap-3 whitespace-nowrap text-xs">
      <span className="flex items-center gap-1">
        <FaWeightHanging size={12} />
        <span className="text-sm font-bold">
          <CargoWeightFormatter value={totalWeightKg} />
        </span>
      </span>
      <span className="flex items-center gap-1">
        <FaPallet size={12} />
        {packageCategorySummaries.length > 0 ? (
          packageCategorySummaries.map((summary) => (
            <span
              key={summary.categoryId}
              className="flex items-center gap-0.5"
            >
              <span className="text-sm font-bold">
                <PackageCountFormatter
                  value={summary.totalCount > 0 ? summary.totalCount : null}
                />
              </span>
              <UnitLabel className="leading-none">{summary.name}</UnitLabel>
            </span>
          ))
        ) : (
          <span className="text-sm font-bold">-</span>
        )}
      </span>
    </div>
  )
}
